import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';

class FavoritesResults extends Component {
    parseLocalStorageArray = (localStorageItemName) =>{
        return localStorage.getItem(localStorageItemName).split("&").slice(0, -1);
    }

    removeFilter = (favoriteId) => {
        let favoriteList = this.parseLocalStorageArray('favorites');
        favoriteList = favoriteList.filter(ele => {
            return ele !== String(favoriteId);
        });
        console.log(favoriteList);
        let values = favoriteList;
        let result = "";
        values.forEach(el => {
            result+=(el+'&');
        });
        localStorage.setItem('favorites', result);

        window.reload();
    }

    render(){
    
        const favorites = this.props.mcards.map((favorite) =>
            <li key={favorite.id}>
                <h3>
                    {favorite.title}
                </h3>
                <p>
                    {favorite.description}
                </p>
                <div className="werkvormoptie">
                    <div className="left">
                        <NavLink to="/favorieten" onClick={this.removeFilter.bind(this, favorite.id)}>
                            <p>
                                Verwijder
                            </p>
                            <img className="verwijdericon" src="img/kruisje-icoon-zwart_2x.png" alt="Kruisje"/>
                        </NavLink>
                    </div>
                    <div className="right">
                        <NavLink to={'/methodekaart/'+favorite.id}>
                            Bekijk werkvorm
                            <img src="img/pijl-rechts-zwart_2x.png" alt="Pijltje" />
                        </NavLink>
                    </div>
                </div>
            </li>
        ) 
        return(
            <div>
            <section className="title">
                <h2>
                    {this.props.mcards.length} favorieten opgeslagen_
                </h2>
            </section>

            {this.props.mcards.length < 1 ? <section className="geenresultaten">
                Je kan een werkvorm aan je favorieten
                toevoegen door op ‘’voeg toe’’ te klikken
                of op het hartvormige icoon. <img src="img/hart-icoon-favorieten-pagina_2x.png" alt="Hartje"/>
            </section> : <section className="resultaten-favorieten">
                <ul>
                    {favorites}
                </ul>
            </section>}       

            
            
                 
            </div>
        )
    }
}

export default FavoritesResults;